export type SortDirection = 'ascending' | 'descending';

export class SortTable {
    /**
     * Initialize a table filter
     * @param _tableElementID
     * @param sortCallback - If you would like the caller to handle the actual sort pass in a callback, if no callback is sent SortTable will handle the sorting in-page
     */
    constructor(
        private _tableElementID: string | HTMLElement,
        private sortCallback?: (sortName: string, sortDirection: SortDirection) => void,
    ) {
        this.initSort();
    }

    private initSort() {
        this.setupSort(this._tableElementID);
        $('[data-direction="default-asc"]').click();
        $('[data-direction="default-desc"]').click().click();
    }

    private setupSort(id) {
        $(`#${id} th`).each((columnIndex, columnElement) => {
            const $column = $(columnElement);
            if ($column.is('[data-binding="sort"]')) {
                let sortOrder;
                $column.click(() => {
                    if (!$column.is('.selected')) {
                        $('.selected i').attr('class', 'fa fa-sort');
                    }
                    if ($column.is('.asc')) {
                        $column.removeClass('asc');
                        $column.addClass('desc selected');
                        $column.find('i').attr('class', 'fa fa-sort-up');
                        sortOrder = -1;
                    } else {
                        $column.addClass('asc selected');
                        $column.removeClass('desc');
                        $column.find('i').attr('class', 'fa fa-sort-down');
                        sortOrder = 1;
                    }
                    $column.siblings().removeClass('asc selected');
                    $column.siblings().removeClass('desc selected');
                    if (this.sortCallback) {
                        this.sortCallback($column.attr('data-sort-name'), sortOrder === 1 ? 'ascending' : 'descending');
                    } else {
                        this._sortInline(columnIndex, sortOrder, id);
                    }
                });
            }
        });
    }

    private _sortInline(columnIndex: number, sortOrder: number, id) {
        const arrData = $(`table#${id}`).find('tbody >tr:has(td)').get();
        arrData.sort(function (a, b) {
            const val1: any = $(a)
                .children('td')
                .eq(columnIndex)
                .text()
                .toUpperCase()
                .trim()
                .replace(/(^\$|,)/g, '');
            const val2: any = $(b)
                .children('td')
                .eq(columnIndex)
                .text()
                .toUpperCase()
                .trim()
                .replace(/(^\$|,)/g, '');
            if (/^[0-9.]+$/.test(val1) && /^[0-9.]+$/.test(val2)) {
                return sortOrder === 1 ? parseFloat(val1) - parseFloat(val2) : parseFloat(val2) - parseFloat(val1);
            } else {
                return val1 < val2 ? -sortOrder : val1 > val2 ? sortOrder : 0;
            }
        });
        $.each(arrData, (index, row) => {
            $(`table#${id} tbody`).append(row);
        });
    }
}
